<template>
  <v-dialog v-model="show" max-width="480" persistent>
    <v-card>
      <v-card-title class="headline">
        <v-icon left color="warning">mdi-alert-circle-outline</v-icon>
        Licencia no activa
      </v-card-title>

      <v-card-text>
        <p class="body-1 mb-1">{{ message }}</p>
        <p class="caption grey--text mb-0">
          El pago se gestiona en el portal seguro de Tollkeep.
        </p>
      </v-card-text>

      <v-card-actions>
        <v-btn text @click="show = false">Cerrar</v-btn>
        <v-spacer></v-spacer>
        <v-btn
          v-if="paymentUrl"
          color="primary"
          depressed
          :href="paymentUrl"
          target="_blank"
          rel="noopener"
        >
          <v-icon left>mdi-credit-card-outline</v-icon>
          Regularizar el pago
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { checkLicense } from "@/services/tollkeepLicense.js";

export default {
  name: "LicenseGate",

  data: () => ({
    show: false,
    message: "",
    paymentUrl: "",
  }),

  methods: {
    /**
     * Valida la licencia de la empresa por su código de tienda.
     * @returns {Promise<boolean>} true = puede entrar; false = vencida (abre el diálogo de cobro).
     */
    async validate(storeCode) {
      const lic = await checkLicense(storeCode);
      if (lic.allowed) return true;

      this.message =
        lic.message ||
        "La licencia de esta tienda no está activa. Regulariza el pago para continuar.";
      this.paymentUrl = lic.payment_url || "";
      this.show = true;
      return false;
    },
  },
};
</script>
